<template>
  <div class="history" :class="guest ? 'container':''">
    <h2 class="profile__header">
      {{ $t('diagnostic.header') }}
    </h2>

    <div class="row">
      <div class="col-12 offset-0 col-lg-6 offset-lg-3">
        <div class="history__form">
          <h4>{{$t('diagnostic.kind')}}</h4>
          <v-select v-model="selectedDiagnosticType"
                    :options="diagnosticTypes"
                    :searchable="false"
                    class="userSelect" label="title">
          </v-select>

          <template v-if="selectedDiagnosticType && selectedDiagnosticType.id">
            <h4>{{ $t('consultations.choose_clinic') }}</h4>
            <div class="history__clinic"
                 v-for="clinic in availableClinics"
                 :class="{ 'history__clinic-active': selectedClinic && clinic.id === selectedClinic.id }"
                 @click="handleChangeClinic(clinic)">
              <h3>{{ clinic.title }}</h3>
              <span>{{ clinic.address }}</span>
            </div>
          </template>

          <button class="btn"
                  v-if="selectedDiagnosticType || selectedDiagnosticType.id"
                  :disabled="selectedClinic === null"
                  @click="searchDiagnostic">
            {{$t('diagnostic.move_to_choose_diagnostics') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import config from '@/helpers/configDateFormats';
import {mapGetters} from "vuex";

export default {
  name: 'order-find-diagnostic',
  props: {
    diagnostic_type_id: {
      required: false,
      type: [Number, String],
    },
    clinic_id: {
      required: false,
      type: [Number, String],
    },
    guest: {
      default: false,
      type: [Boolean],
    },
    language: {
      default: 'ru',
      type: [String],
    },
  },
  data() {
    return {
      selectedDiagnosticType: null,
      selectedClinic: null,
      availableClinics: [],
    }
  },
  computed: {
    ...mapGetters([
      'diagnosticTypes',
      'clinics',
    ])
  },
  watch: {
    selectedDiagnosticType(value) {
      this.selectedClinic = null;
      this.availableClinics = this.getDiagnosticTypeClinics(value);
    }

  },
  methods: {
    getDiagnosticTypeClinics(diagnosticType) {
      if (diagnosticType && diagnosticType.clinics) {
        let clinics = this.clinics.filter(clinic => {
          return diagnosticType.clinics.includes(clinic.id);
        });

        if (clinics.length === 1) {
          this.selectedClinic = clinics[0];
        }

        return clinics;
      }

      return [];
    },
    formatDate(date) {
      return moment(date).format(config.DATE_FORMAT_OUTPUT);
    },
    handleChangeClinic(clinic) {
      if (clinic === this.selectedClinic) {
        this.selectedClinic = null;
      } else {
        this.selectedClinic = clinic;
      }
    },
    searchDiagnostic() {
      let query = {};

      if (this.selectedDiagnosticType) {
        query = {
          ...query,
          diagnostic_type_id: this.selectedDiagnosticType.id,
        };
      }

      if (this.selectedClinic) {
        query = {
          ...query,
          clinic_id: this.selectedClinic.id,
        };
      }

      if (this.guest) {
        this.$router.push({
          name: 'order.choose-diagnostic',
          query,
        })
      } else {
        this.$router.push({
          name: 'profile.order.choose-diagnostic',
          query,
        })
      }
    },
  },
  mounted() {
    if(this.guest){
      this.$store.dispatch('setLanguage', {language:this.language})
    }
    this.$store
        .dispatch('getDiagnosticTypes')
        .then(() => {
          this.selectedDiagnosticType = {
            id: null,
            title: this.$t('diagnostic.kind_select'),
            service_name: this.$t('diagnostic.kind_select')
          };

          for (let diagnosticType of this.diagnosticTypes) {
            if (diagnosticType.id === Number.parseInt(this.diagnostic_type_id)) {
              this.selectedDiagnosticType = diagnosticType;
              break;
            }
          }
        });

    for (let clinic of this.clinics) {
      if (clinic.id === Number.parseInt(this.clinic_id)) {
        this.selectedClinic = clinic;
        break;
      }
    }
  },
}
</script>
